/**
 * Wie weit zwei Punkte auseinanderliegen — in Metern.
 *
 * **Eine Formel und nicht zwei.** Sie stand als vier Zeilen mitten in der
 * Fotowahl; als die Umgebungssuche dieselbe Rechnung brauchte, war die Wahl
 * zwischen einer Kopie und dieser Datei. Eine Kopie wäre die Stelle, an der
 * später eine der beiden angefasst wird und die andere nicht — genau die Art
 * Fehler, die dieses Projekt in dieser Sitzung viermal hatte.
 *
 * Ebene Näherung und keine Kugelgeometrie: hier geht es um Hunderte Meter um
 * einen Punkt herum, nicht um Kurse über den Atlantik. Der Kosinus der Breite
 * muss trotzdem sein — in Nordnorwegen ist ein Längengrad halb so breit wie am
 * Mittelmeer, und ohne ihn wäre jede Entfernung dort um die Hälfte daneben.
 */
export function meterZwischen(
  latA: number,
  lonA: number,
  latB: number,
  lonB: number,
): number {
  const meterProGrad = 111320
  const dy = (latB - latA) * meterProGrad
  const dx = (lonB - lonA) * meterProGrad * Math.cos((latA * Math.PI) / 180)
  return Math.sqrt(dx * dx + dy * dy)
}

/**
 * Dieselbe Zahl, wie man sie sagt.
 *
 * Unter einem Kilometer in Metern und auf zehn gerundet: „240 m" ist eine
 * Auskunft, „237,4 m" eine Behauptung, die die Rechnung oben gar nicht deckt.
 */
export function entfernungText(meter: number): string {
  if (meter < 1000) return `${Math.round(meter / 10) * 10} m`
  return `${(meter / 1000).toFixed(1).replace('.', ',')} km`
}
